import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import { setSession } from "../reducers/session";
import store from "../store";

// LOGIN
export const _login = (data) => {
  const request = {
    endPoint: serviceRouteConstants.login,
    data: {
      ...data,
      platform: "Web",
    },
  };
  return post(request);
};

// VALIDATING EMAIL
export const _validate_email = (data) => {
  // console.log('_validate_email =>',data)
  const request = {
    endPoint: serviceRouteConstants.validate_email,
    data: data,
  };
  // console.log('request =>', request)
  return post(request);
};

// SET NEW PASSWORD
export const _set_new_password = (data) => {
  const session = store.getState().session;
  let {
    session: { user_id, user_type, user_token, reset_user_id, reset_user_type },
  } = session;
  if (reset_user_type == "ClientUser") {
    reset_user_type = "client_user";
  }

  let newPassword = data.new_password;
  let resetPasswordAction = data.password_action;
  let setNewPasswordType = data.set_new_password_type;
  let setPasswordId = data.set_password_id;

  let endPoint = "";
  if (resetPasswordAction == "ChangePassword") {
    if (user_id && user_type && user_token) {
      let oldPassword = data.old_password;
      data = {
        new_password: newPassword,
        action: resetPasswordAction,
        old_password: oldPassword,
        platform: "Web",
      };
      endPoint = "change_password";
    }
  } else if (resetPasswordAction == "Reset") {
    if (reset_user_id) {
      data = {
        new_password: newPassword,
        action: resetPasswordAction,
        user_id: reset_user_id,
        platform: "Web",
        userType: reset_user_type,
      };
      endPoint = "reset_password";
    }
  } else {
    data = {
      new_password: newPassword,
      action: resetPasswordAction,
      user_id: setPasswordId,
      platform: "Web",
      userType: setNewPasswordType,
    };
    endPoint = "set_new_client_password";
  }

  const request = {
    endPoint: endPoint,
    data: data,
  };
  return post(request);
};

// VERIFY LOGIN OTP
export const _verifyLoginOtp = (data) => {
  // console.log('data',data)
  // console.log('session',session?.session?.user_type)
  const session = store.getState().session;
  const request = {
    endPoint: "verify_otp",
    data: {
      ...data,
      platform: "Web",
      type: session?.session?.user_type?.toLowerCase(),
    },
  };
  return post(request);
};

/**
 * Sends a request to resend the login OTP using the provided data.
 *
 * @param {Object} data - the data for the request
 * @return {Promise} a Promise that resolves with the result of the request
 */
export const _resendLoginOtp = (data) => {
  const session = store.getState().session;
  const request = {
    endPoint: serviceRouteConstants.resendLoginOtp,
    data: {
      ...data,
      platform: "Web",
      type: session?.session?.user_type?.toLowerCase(),
    },
  };
  return post(request);
};

/**
 * An asynchronous function for handling the forgot password feature.
 *
 * @param {Object} data - the data for the password reset request
 * @return {Promise} the result of the password reset request
 */
export const _forgotPassword = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.forgotPassword,
    data: data,
  };
  return await post(request);
};

/**
 * Set a new password for the user.
 *
 * @param {object} data - The data containing the new password
 * @return {Promise} The result of the password update request
 */
export const _setNewPassword = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.setNewPassword,
    data: data,
  };
  return await post(request);
};

/**
 * Verify the provided code by making a POST request to the user.email_verify route.
 *
 * @param {Object} data - The data to be sent in the POST request.
 * @return {Promise} The result of the POST request.
 */
export const _verifyCode = async (data) => {
  let verifyCode = data.verify_code;
  let userEmail = data.user_email;
  let userType = data.user_type;
  let action = data.action || "Register";
  let postData = {
    verification_code: verifyCode,
    user_id: userEmail,
    platform: "Web",
    action: action,
  };

  const request = {
    endPoint: serviceRouteConstants.verifyEmail,
    data: postData,
  };
  return await post(request);
};

/**
 * Asynchronous function for user sign up.
 *
 * @param {Object} data - The data for user sign up
 * @return {Promise} The result of the sign up request
 */
export const _signUp = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.signUp,
    data: data,
  };
  return await post(request);
};

/**
 * Verify the email using the provided data.
 *
 * @param {Object} data - The data needed to verify the email
 * @return {Promise} The result of the email verification
 */
export const _verifyEmail = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.verifyEmail,
    data: data,
  };
  return await post(request);
};

/**
 * Sends a request to resend the verification code for the user's email.
 *
 * @param {Object} data - The data containing information necessary for resending the verification code.
 * @return {Promise} The result of the post request for resending the verification code.
 */

export const _resendVerifyEmailOtp = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.resendVerificationCode,
    data: data,
  };
  return await post(request);
};

/**
 * Verify an account using the provided data.
 *
 * @param {Object} data - The data to be used for account verification
 * @return {Promise} The result of the account verification request
 */
export const _verifyAccount = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.verifyAccount,
    data: data,
  };
  return await post(request);
};

/**
 * Verify user account during login.
 *
 * @param {Object} data - the data to be sent in the request
 * @return {Promise} the result of the post request
 */
export const LoginVerifyAccount = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.verifyLoginAccount,
    data: data,
  };
  return await post(request);
};

export const _ClientBranchList = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.clientBranchList,
    data: data,
  };
  return await post(request);
};

export const _impersonateUser = async (data) => {
  let clientId = data.client_id;
  let sessionState = store.getState().session;
  let original = sessionState.session.user_id;
  if (clientId != original) {
    let is_headoffice = sessionState.session.is_headoffice;
    if (is_headoffice == 1) {
      store.dispatch(
        setSession({
          original_user: original,
        }),
      );
    }
  }

  const request = {
    endPoint: serviceRouteConstants.impersonateClient,
    data: data,
  };
  return await post(request);
};
